import { IconButton, Tooltip } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import { PropsWithChildren } from 'react';
import { BaseDialog } from './BaseDialog';
import { Account, Features } from './types';

export interface BaseEditIconProps {
  workloadData: Account | undefined;
  requesterEmail: string;
  handleClickOpen: any;
  isModalOpen: boolean;
  handleClose: any;
  handleConfirm: any;
  disableConfirm: boolean;
  apiValidationPayload: any;
  features?: Features;
  isLoading: boolean;
  isLoadingEdit: boolean;
  dialogTitle: string;
  settingName?: string;
  allowOwnerEdit?: boolean;
  allowEngineerEdit?: boolean;
}

export function BaseEditIcon(props: PropsWithChildren<BaseEditIconProps>) {
  function allowEditAccess(): boolean {
    if (props.allowOwnerEdit) {
      if (
        props.workloadData?.ownerMembers
          ?.filter(member => member !== null)
          ?.map(member => member.toLowerCase())
          .includes(props.requesterEmail.toLowerCase())
      ) {
        return true;
      }
    }
    if (props.allowEngineerEdit) {
      if (
        props.workloadData?.engineerMembers
          ?.filter(member => member !== null)
          ?.map(member => member.toLowerCase())
          .includes(props.requesterEmail.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  }

  const canEdit = allowEditAccess();

  let title = '';
  if (props.isLoadingEdit || !props.workloadData) {
    title = 'Loading...';
  } else if (canEdit) {
    title = `Edit ${props.settingName ?? props.dialogTitle}`;
  } else {
    title = 'Contact an account owner to request access';
  }

  return (
    <>
      <Tooltip title={title}>
        <span>
          <IconButton
            onClick={props.handleClickOpen}
            disabled={props.isLoadingEdit || !canEdit}
            aria-label={title}
          >
            <Edit />
          </IconButton>
        </span>
      </Tooltip>
      {props.children ? (
        <BaseDialog
          open={props.isModalOpen}
          handleClose={props.handleClose}
          handleConfirm={props.handleConfirm}
          disableConfirm={props.disableConfirm}
          title={props.dialogTitle}
          isLoading={props.isLoading}
        >
          {props.children}
        </BaseDialog>
      ) : null}
    </>
  );
}
